import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const classes = {
  paper: css`
    padding: ${spacing(2, 2, 0, 2)};
    position: relative;
    z-index: 1;
  `,
  paperBackground: css`
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3, 3, 0, 0)};
    filter: drop-shadow(${cssTheme.shadows.topNormal});
  `,
}
